import { useEffect } from "react";
import { isCordovaAvailable } from "./secureStorageUtil";

const EDGE_THRESHOLD = 30;
const MIN_SWIPE_DISTANCE = 80;
const MAX_VERTICAL_RATIO = 0.6;
const NAVIGATION_COOLDOWN_MS = 600;

const useSwipeBack = () => {
    useEffect(() => {
        if (!isCordovaAvailable()) return;

        let touchStartX = null;
        let touchStartY = null;
        let tracking = false;
        let lastNavigationTime = 0;

        const resetGesture = () => {
            tracking = false;
            touchStartX = null;
            touchStartY = null;
        };

        const onTouchStart = (e) => {
            const touch = e.touches[0];
            if (touch.clientX <= EDGE_THRESHOLD) {
                touchStartX = touch.clientX;
                touchStartY = touch.clientY;
                tracking = true;
            } else if (tracking) {
                resetGesture();
            }
        };

        const onTouchMove = (e) => {
            if (!tracking) return;
            const touch = e.touches[0];
            const deltaX = touch.clientX - touchStartX;
            const deltaY = Math.abs(touch.clientY - touchStartY);

            if (deltaX > 0 && deltaY / deltaX > MAX_VERTICAL_RATIO) {
                tracking = false;
            }
        };

        const onTouchEnd = (e) => {
            if (!tracking) return;

            const touch = e.changedTouches[0];
            const deltaX = touch.clientX - touchStartX;
            const deltaY = Math.abs(touch.clientY - touchStartY);
            const now = Date.now();

            resetGesture();

            if (
                deltaX >= MIN_SWIPE_DISTANCE &&
                deltaY / deltaX <= MAX_VERTICAL_RATIO &&
                now - lastNavigationTime > NAVIGATION_COOLDOWN_MS &&
                window.history.length > 1
            ) {
                lastNavigationTime = now;
                window.history.back();
            }
        };

        const onTouchCancel = () => {
            resetGesture();
        };

        const opts = { passive: true, capture: true };

        window.addEventListener("touchstart", onTouchStart, opts);
        window.addEventListener("touchmove", onTouchMove, opts);
        window.addEventListener("touchend", onTouchEnd, opts);
        window.addEventListener("touchcancel", onTouchCancel, opts);

        return () => {
            const captureOpt = { capture: true };
            window.removeEventListener("touchstart", onTouchStart, captureOpt);
            window.removeEventListener("touchmove", onTouchMove, captureOpt);
            window.removeEventListener("touchend", onTouchEnd, captureOpt);
            window.removeEventListener("touchcancel", onTouchCancel, captureOpt);
        };
    }, []);
};

export default useSwipeBack;
